import React, { FC, useEffect } from 'react';
import { AuthPageWrapper } from '@homeproved/pro/ui';
import { useRouter } from 'next/router';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { LoginForm } from './LoginForm';
import { useCookies } from 'react-cookie';
import { getURLWithoutSubdomain } from '@homeproved/shared/util';
import { useMediaQuery, useTheme } from '@material-ui/core';
let routerQueryHandled = false;

export const LoginPage: FC = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.sm));
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [cookies, removeCookie] = useCookies(['upgrade_modal']);

  const cookieDomain =
    typeof window !== 'undefined' ? getURLWithoutSubdomain(window.location.hostname) : undefined;

  useEffect(() => {
    if (!cookies['upgrade_modal']) return;
    removeCookie('upgrade_modal', false, {
      path: '/',
      domain: cookieDomain,
    });
  }, [cookies, removeCookie, cookieDomain]);

  useEffect(() => {
    if (routerQueryHandled) return;
    routerQueryHandled = true;
    if (router.query.from === 'password-forgotten' && !!router.query.email) {
      enqueueSnackbar(
        t('app.pro.pages.login.fromPasswordForgotten').replace(
          '%EMAIL%',
          router.query.email.toString() || ''
        ),
        {
          variant: 'info',
          onExited: () => {
            closeSnackbar();
          },
          preventDuplicate: true,
        }
      );
    }

    if (router.query.from === 'password-reset') {
      enqueueSnackbar(t('app.pro.pages.login.fromPasswordReset'), {
        variant: 'info',
        onExited: () => {
          closeSnackbar();
        },
        preventDuplicate: true,
      });
    }
  });

  return (
    <AuthPageWrapper isTablet={isTablet}>
      <LoginForm />
    </AuthPageWrapper>
  );
};
